export default "__VITE_ASSET__BYyrxG2v__"